import { render } from "./HelpDialogWorkflowAiPrompt.vue?vue&type=template&id=f40b48b2"
import script from "./HelpDialogWorkflowAiPrompt.vue?vue&type=script&lang=js"
export * from "./HelpDialogWorkflowAiPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__